module.exports = __webpack_public_path__ + "img/web_sg_boards_1.107423f9.jpg";